// Role
export const User = "user";
export const Admin = "admin";
export const Super_Admin = "super-admin";
export const Collaborator = "collaborator";
export const Customer = "customer";
export const Stakeholder = "stakeholder";

// Routes
export const routes = {
  "super-admin": [
    {
      label: "Overview",
      path: "/",
      icon: "fal fa-home-lg-alt",
    },
    {
      label: "Manage Orders",
      path: "/order/overview",
      icon: "fa-light fa-file-invoice",
    },
    {
      label: "Manage Inventory",
      path: "/inventory/overview",
      icon: "fa-light fa-warehouse",
    },
    {
      label: "Booking",
      path: "/booking/overview",
      icon: "fal fa-clone",
    },
    {
      label: "Analytics",
      path: "/analytics",
      icon: "fal fa-analytics",
    },
    {
      label: "Chat",
      path: "/chat",
      icon: "fal fa-comment-alt",
    },
    {
      label: "Requests",
      path: "/requests/overview",
      icon: "fal fa-clipboard-list",
    },
    {
      label: "Manage To Dos",
      path: "/activity/overview",
      icon: "fal fa-sticky-note",
    },
    {
      label: "Manage Workflows",
      path: "/workflows",
      icon: "fal fa-random",
    },
    {
      label: "Manage Templates",
      path: "/booking/design/overview",
      icon: "fal fa-th-large",
    },
    {
      label: "Manage Components",
      path: "/component/create",
      icon: "fal fa-toggle-on",
    },
    {
      label: "Manage SKUs",
      path: "/sku/overview",
      icon: "fa-light fa-square",
    },
    {
      label: "Manage Products",
      path: "/product/overview",
      icon: "fa-light fa-grid-2",
    },
  ],
  admin: [
    {
      label: "Overview",
      path: "/",
      icon: "fal fa-home-lg-alt",
    },
    {
      label: "Manage Orders",
      path: "/order/overview",
      icon: "fa-light fa-file-invoice",
    },
    {
      label: "Manage Inventory",
      path: "/inventory/overview",
      icon: "fa-light fa-warehouse",
    },
    {
      label: "Booking",
      path: "/booking/overview",
      icon: "fal fa-clone",
    },
    {
      label: "Analytics",
      path: "/analytics",
      icon: "fal fa-analytics",
    },
    {
      label: "Chat",
      path: "/chat",
      icon: "fal fa-comment-alt",
    },
    {
      label: "Requests",
      path: "/requests/overview",
      icon: "fal fa-clipboard-list",
    },
    {
      label: "Manage To Dos",
      path: "/activity/overview",
      icon: "fal fa-sticky-note",
    },
    {
      label: "Manage Workflows",
      path: "/workflows",
      icon: "fal fa-random",
    },
    {
      label: "Manage Templates",
      path: "/booking/design/overview",
      icon: "fal fa-th-large",
    },
    {
      label: "Manage Components",
      path: "/component/create",
      icon: "fal fa-toggle-on",
    },
    {
      label: "Manage SKUs",
      path: "/sku/overview",
      icon: "fa-light fa-square",
    },
    {
      label: "Manage Products",
      path: "/product/overview",
      icon: "fa-light fa-grid-2",
    },
  ],
  user: [
    {
      label: "Overview",
      path: "/",
      icon: "fal fa-home-lg-alt",
    },
    {
      label: "Chat",
      path: "/chat",
      icon: "fal fa-comment-alt",
    },
  ],
  collaborator: [
    {
      label: "Overview",
      path: "/",
      icon: "fal fa-home-lg-alt",
    },
  ],
  customer: [
    {
      label: "Overview",
      path: "/",
      icon: "fal fa-home-lg-alt",
    },
    {
      label: "Booking",
      path: "/booking/overview",
      icon: "fal fa-clone",
    },
  ],
};
